<template>
    <div class="ei-detail">
        <div v-if="masterLoading" class="ei-detail-loading"><i class="fas fa-spinner fa-spin"></i> 로드 중…</div>
        <div v-else-if="masterLoadError" class="ei-detail-error">{{ masterLoadError }}</div>
        <template v-else>
            <div class="ei-single-head">
                <div class="ei-single-head-main">
                    <div class="ei-single-title">
                        <i class="fas fa-layer-group ei-single-icon"></i>
                        <span>{{ detailTitle }}</span>
                    </div>
                </div>
            </div>

            <section class="ei-tab-section">
                <div class="ei-tab-body">
                    <EnIntDataWorkspace
                        v-if="workspaceReady"
                        ref="dataWorkspace"
                        :en-int-idx="enIntIdx"
                        :master-api-state="masterApiState"
                        :shared-calc-list-api-state="sharedCalcListApiState"
                        :date-type="dateType"
                        :date-value="dateValue"
                        @saved="onDataSaved"
                    />
                </div>
            </section>
        </template>
    </div>
</template>

<script>
import EnIntDataWorkspace from "./EnIntDataWorkspace.vue";

export default {
    name: "EnIntMasterDetailPanel",
    components: { EnIntDataWorkspace },
    props: {
        enIntIdx: { type: Number, required: true },
        dateType: { type: String, required: true },
        dateValue: { type: Number, required: true },
        /** 상위에서 단일 getMaster로 조회 */
        masterApiState: {
            type: Object,
            default: () => ({ response: null, data: null, loading: false, error: "" }),
        },
        /** 상위에서 단일 getCalcList로 조회 */
        sharedCalcListApiState: {
            type: Object,
            default: () => ({ response: null, data: null, loading: false, error: "" }),
        },
    },
    computed: {
        master() {
            return this.masterApiState?.data || {};
        },
        masterLoading() {
            return Boolean(this.masterApiState?.loading);
        },
        masterLoadError() {
            return this.masterApiState?.error || "";
        },
        /** 이전 선택의 마스터가 남아 있거나 로딩 전 깜빡임일 때 워크스페이스를 붙이지 않음 */
        workspaceReady() {
            if (this.masterLoading || this.masterLoadError) return false;
            const mid = Number(this.master?.enIntIdx ?? this.master?.en_int_idx);
            if (!Number.isFinite(mid) || mid <= 0) return false;
            return mid === Number(this.enIntIdx);
        },
        detailTitle() {
            return "데이터 입력 · 추이 분석";
        },
        categoryBadge() {
            const category = String(this.master?.enIntCategory || "").trim();
            return category ? `카테고리 ${category}` : "카테고리 정보 없음";
        },
    },
    methods: {
        onDataSaved() {
            this.$emit("data-saved");
        },
    },
};
</script>

<style scoped>
.ei-detail {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    background: linear-gradient(180deg, rgba(248, 250, 252, 0.96), rgba(241, 245, 249, 0.72));
}

.ei-detail-loading {
    padding: 28px;
    text-align: center;
    color: #64748b;
    font-size: 13px;
    font-weight: 600;
}

.ei-detail-error {
    padding: 12px 14px;
    border-radius: 8px;
    background: rgba(220, 38, 38, 0.08);
    color: #991b1b;
    font-size: 13px;
    font-weight: 600;
}

.ei-single-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
    margin: 15px 23px 4px 23px;
    flex-shrink: 0;
}

.ei-single-head-main {
    min-width: 0;
}

.ei-single-title {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 16px;
    font-weight: 700;
    color: #64748b;
    margin-left: 0;
}

.ei-single-icon {
    color: #0e7490;
}

.ei-single-subtitle {
    margin: 3px 0 0;
    color: #6b7280;
    font-size: 10px;
    line-height: 1.4;
}

.ei-single-chip {
    display: inline-flex;
    align-items: center;
    min-height: 20px;
    padding: 1px 8px;
    border-radius: 999px;
    border: 1px solid rgba(14, 116, 144, 0.18);
    background: rgba(14, 116, 144, 0.07);
    color: #0f766e;
    font-size: 10px;
    font-weight: 700;
    white-space: nowrap;
}

.ei-tab-section {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.ei-tab-body {
    flex: 1;
    min-height: 0;
    overflow: hidden;
}

@media (max-width: 720px) {
    .ei-single-head {
        flex-direction: column;
        align-items: flex-start;
    }
}
</style>
